import { useMutation, useQueryClient } from '@tanstack/react-query';
import { licenseDeviceKeys } from '@platform/billing';
import { licenseDeviceApi } from './license-device.api';

/** 본인 기기 별명 변경. 빈 값은 null 로 보내 별명을 지운다(PC 이름으로 표시). */
export function useRenameMyDevice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ deviceId, nickname }: { deviceId: string; nickname: string }) =>
      licenseDeviceApi.renameMine(deviceId, { nickname: nickname.trim() || null }),
    onSettled: () =>
      qc.invalidateQueries({ queryKey: licenseDeviceKeys.mine }),
  });
}
